module.exports = __webpack_public_path__ + "img/empty.1a72d9b1.svg";